module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("1、MAC上MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("双击菜单栏的MOA图标打开MOA：")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/moaVersionView/moaVersionView_pic03.png"),
      "width": "480px",
      "height": "170px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("「帮助」-->「版本更新」-->「更新版本」")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/moaVersionView/moaVersionView_pic01.png"),
      "width": "940px",
      "height": "500px"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("2、Windows上MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("双击菜单栏中已运行的MOA图标打开MOA：")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/moaVersionView/moaVersionView_pic04.png"),
      "width": "480px",
      "height": "170px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("查看版本信息：")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/moaVersionView/moaVersionView_pic02.png"),
      "width": "940px",
      "height": "500px"
    }
  })]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("3、如果无法打开MOA，或者更新不到最新版本")]), _vm._v(" "), _c('p', [_vm._v("如果无法打开MOA或者更新不到最新版本，请直接按照安装指导，下载最新版MOA覆盖安装即可。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45f95126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/moaUninstallURL/moaVersionView.vue
// module id = 643
// module chunks = 1